import { $ } from '@starberry/components';
import Services from 'core/services/store/auth/services';
import * as AuthActions from 'core/services/store/auth/actions';
import { Routes } from '../../routes';

export default [
  {
    $: 'SideMenuItem',
    label: 'Back to Website',
    href: $('constants.website-url'),
    icon: $('constants.icons.backToWebsite'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'Dashboard',
    href: Routes.DashboardPage,
    icon: $('constants.icons.home'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'My Property',
    href: Routes.MyPropertyPage,
    icon: $('constants.icons.dashboard'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'Inbox',
    href: Routes.InboxPage,
    icon: $('constants.icons.notification'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'Calendar',
    href: Routes.CalendarPage,
    icon: $('constants.icons.calendar'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'Profile',
    href: Routes.ProfilePage,
    icon: $('constants.icons.profile'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
  {
    $: 'SideMenuItem',
    label: 'Logout',
    provide: ['auth'],
    onClick: (_, context) => () => {
      const [, dispatch] = context?.state?.auth || [];
      Services(dispatch, AuthActions).logout();
      window.location = Routes.LoginPage;
    },
    icon: $('constants.icons.logout'),
    visibility: {
      desktop: true,
      mobile: true,
      tabs: true,
    },
  },
];
